import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@nexus/fff-ui-shared/Modal';
import Button from '@nexus/fff-ui-shared/Button';

import styles from './SubscriptionConfirmationModal.module.scss';

const SUPPORT_LINK =
  'https://support.fabfitfun.com/?a=How-do-additional-Subscriptions-work---id--A6DxNNWIQJ2Kc-qqEcnWyA';
const USE_SALE_TERMS_LINK = 'https://legal.fabfitfun.com/';
const MEMBERSHIP_TERMS_LINK =
  'https://legal.fabfitfun.com/#refills-terms-conditions';

const SubscriptionConfirmationModal = ({
  isOpen,
  onClickCancel,
  onClickSubscribe,
}) => (
  <Modal isOpen={isOpen} className={styles.modal}>
    <div className={styles.container}>
      <h1 role="modal-title">Recurring Shipments of Your Favorite Products</h1>
      <p role="modal-disclaimer">
        Subscribe & Save is a subscription service that is billed each season
        and will be automatically charged using the payment method provided on
        your account. Foreign exchange or transaction fees may apply for non-US
        customers. You may cancel your reFills subscription at any time online
        or by contacting FabFitFun Support at 1.855.313.6267. For more details,{' '}
        <a href={SUPPORT_LINK}>click here</a>.
      </p>
      <p role="modal-disclaimer">
        By clicking “Subscribe” you are agreeing to our{' '}
        <a href={USE_SALE_TERMS_LINK}>Terms of Use and Sale</a> and{' '}
        <a href={MEMBERSHIP_TERMS_LINK}>Subscribe & Save Membership Terms</a>.
      </p>
    </div>
    <div className={styles.buttonContainer}>
      <Button onClick={onClickCancel} width="100%" variation="black-outline">
        Cancel
      </Button>
      <Button onClick={onClickSubscribe} width="100%">
        Subscribe
      </Button>
    </div>
  </Modal>
);

SubscriptionConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  onClickSubscribe: PropTypes.func.isRequired,
};

export default SubscriptionConfirmationModal;
